import { CSSProperties, HTMLProps } from 'react';
import styled, { css } from 'styled-components';
import { Icon, IconName, InternalIconName } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';

const IconContainer = styled.div<{
  $display: string;
  $color: string;
  $hoverColor: string;
  $hasOnClick: boolean;
}>`
  display: ${props => props.$display};
  user-select: none;
  ${props => css`
    cursor: ${props.$hasOnClick ? 'pointer' : 'default'};
    color: ${props.$color};
    &:hover {
      color: ${props.$hoverColor};
    }
  `}
`;

type IconClickableProps = {
  iconName: IconName | InternalIconName;
  color?: string;
  hoverColor?: string;
  tooltipText?: string;
  display?: string;
  containerStyle?: CSSProperties;
} & HTMLProps<HTMLElement>;

const IconClickable = ({
  iconName,
  onClick,
  color = colors.grey700,
  hoverColor = colors.grey900,
  tooltipText,
  display = 'inline-block',
  containerStyle,
  role,
  'aria-label': ariaLabel,
  ...rest
}: IconClickableProps) => (
  <IconContainer
    $color={color}
    $hoverColor={hoverColor}
    $hasOnClick={Boolean(onClick)}
    onClick={onClick}
    data-tooltip-text={tooltipText}
    $display={display}
    style={containerStyle}
    role={role}
    aria-label={ariaLabel}
  >
    <Icon iconName={iconName} {...rest} />
  </IconContainer>
);

export { IconClickable };
